import "./Tutor.scss";
import { Autocomplete, Card, Checkbox, Chip, FormControl, FormControlLabel, FormLabel, MenuItem, RadioGroup, Select, TextField, Tooltip } from "@mui/material";
import { Field, Formik, useFormikContext } from "formik";
import * as yup from "yup";
import {
  API_RESPONSE,
  I18_TRANSLATION_COMMON,
  MODES,
  NUMBER_CONSTANTS,
  PROFESSIONAL_DETAILS,
  ROUTES,
  STORAGE_KEYS,
  TOASTER_CONFIGS,
  VALIDATION_CONSTANT,
} from "../../../../../Utilities/Constants/Constants";
import { useTranslation } from "react-i18next";
import { ReactNode, useEffect, useState } from "react";
import {
  ERROR_MESSAGES,
  REGEX,
  REGISTRATION_ERRORS,
} from "../../../../../Utilities/Constants/Validations";
import close from "../../../../../../Assets/Sessions/close.svg";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import API_END_POINTS from "../../../../../Utilities/Constants/ApiEndpoints";
import plus from "../../../../../../Assets/Registration/plus.svg";
import { toast } from "react-toastify";
import Radio from '@mui/material/Radio';
import { axiosInstance } from "../../../../../Services/Interceptor/Interceptor";
import { GetSessionStorageData, nullUndefinedEmptyCheck, numberOnly } from "../../../../../Services/Helpers/Helper";
import EditIcon from '@mui/icons-material/Edit';
import DoneIcon from '@mui/icons-material/Done';
import ClearIcon from '@mui/icons-material/Clear';
import { useLocation } from "react-router-dom";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CategoryValidationDialog from "../../../../../Shared/CategoryValidationDialog/CategoryValidationDialog";



const Tutor = (props: any) => {
  const { t, i18n } = useTranslation(I18_TRANSLATION_COMMON.COMMON);
  const [selectedSubjects, setSelectedSubjects]: any = useState([]);
  const [courseSubject, setCourseSubject]: any = useState(" ")
  const [modeOfTeching, setModeOfTeaching] = useState<any>("");

  const [mode, setMode] = useState(MODES.EDIT);
  const [subjectList, setSubjectList]: any = useState([]);
  const [subjectListCopy, setSubjectListCopy]: any = useState([]);
  const [skillsList, setSkillsList]: any = useState([]);
  const [currentTag, setCurrentTag] = useState("");
  const [skillsTouched, setSkillsTouched] = useState<any>(API_RESPONSE.FALSE);
  const [formSubmitted, setFormSubmitted] = useState(API_RESPONSE.FALSE);
  const [experience, setExperience] = useState('');
  const [experienceErrText, setExperienceErrText] = useState(false);
  const [expSubject, setExpSubject]: any = useState([]);
  const [coursePayload, setCoursePayload]: any = useState([]);
  const [personalDetail, setPersonalDetail]: any = useState({});
  const [courses, setCourses]: any = useState([]);
  const [userType, setuserType]: any = useState("");
  const [expectedFee, setExpectedFee] = useState("");
  const [minimumGradeYear, setMinimumGradeYear]: any = useState([]);
  const [maximumGradeYear, setMaximumGradeYear]: any = useState("");
  const [gradeType, setGradeType] = useState<any>("grade");
  const [courseFormSubmitted, setCourseFormSubmitted] = useState(API_RESPONSE.FALSE);
  const [curriculamList, setCurriculamList]: any = useState([]);
  const [gradesList, setGradesList]: any = useState([]);
  const [yearsList, setYearsList]: any = useState([]);
  const [highestQulaificationList, setHighestQualificationList] = useState<any>([]);
  const [degreeList, setDegreeList] = useState<any>([]);
  const [enableDegree, setEnableDegree] = useState(false);
  const [gradesListIndex, setGradesListIndex]: any = useState([]);
  const [editable, setEditable] = useState("");
  const [initialValues, setInitialValues] = useState({
    [PROFESSIONAL_DETAILS.DEGREE]: "",
    // [PROFESSIONAL_DETAILS.SUBJECT]: "",
    [PROFESSIONAL_DETAILS.CURRICULAM]: [],
    // [PROFESSIONAL_DETAILS.TEACHING_MODE]: '',
    // [PROFESSIONAL_DETAILS.EXPERIENCE]: "",
    [PROFESSIONAL_DETAILS.SKILLS]: "",
  });
  let UNITED_ARAB = 'United Arab Emirates';
  const [country, setCountry] = useState<string>(UNITED_ARAB);
  const [region, setRegion] = useState<any>([])
  const [categoryValidationDetails, setCategoryValidationDetails] = useState<any>("")
  const [categoryValidationMessage, setCategoryValidationMessage] = useState<any>("")
  const [open, setOpen] = useState<boolean>(false)
  const [locations, setLocations] = useState<{ state: string; latitude: number; longitude: number, radius: number }[]>([]);
  const location = useLocation();

  const handleClose = () => {
    setOpen(false)
  }

  const getHighestQualification = (type: number) => {
    axiosInstance.get(API_END_POINTS.HIGHEST_QUALIFICATION_LIST + `?parent_id=${type}`).then((response: any) => {
      if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {

        if (type === 0) {
          setHighestQualificationList([...response.data.result.data]);
          setDegreeList([]);
        } else {
          setDegreeList([...response.data.result.data]);
          response.data.result.data?.length > 0 ?
            setEnableDegree(true) :
            setEnableDegree(false);

        }
      }
    })
  };


  useEffect(() => {
    setuserType(GetSessionStorageData(STORAGE_KEYS.ROLE));
    getHighestQualification(0);
  }, []);

  useEffect(() => {

    if (userType === `${NUMBER_CONSTANTS.FIVE}`) {
      getCategoriesList(API_END_POINTS.GET_RECREATIONAL);
      getRegistrationDetail(API_END_POINTS.GET_CAMP_DETAILS);
      getCurriculamList();
    } else if (userType === `${NUMBER_CONSTANTS.NINE}`) {
      getCategoriesList(API_END_POINTS.GET_RECREATIONAL);
      getRegistrationDetail(API_END_POINTS.GET_PERSONAL_DETAILS);
      getCurriculamList();
    } else if (userType === `${NUMBER_CONSTANTS.FOUR}`) {
      getCategoriesList(API_END_POINTS.GET_CATEGORY_LIST);
      getRegistrationDetail(API_END_POINTS.GET_SPDETAILS);
      getCurriculamList();
      getGradesList(`False`);
      // getGradesList(`True`);
    }

  }, [userType]);

  useEffect(() => {
    if (personalDetail)
      setDetails();
  }, [personalDetail]);


  const setDetails = () => {
    if (personalDetail.subject_and_experience?.length > NUMBER_CONSTANTS.ZERO) {
      personalDetail.degree ? setEnableDegree(true) : setEnableDegree(false);
      getDegreeList(personalDetail?.high_education);
      setInitialValues({
        [PROFESSIONAL_DETAILS.DEGREE]: personalDetail.degree,
        [PROFESSIONAL_DETAILS.HIGHER_EDUCATION]: personalDetail.high_education,
        [PROFESSIONAL_DETAILS.DEGREE_SUBJECT]: personalDetail.degree_subject,

        // [PROFESSIONAL_DETAILS.SUBJECT]: "",
        [PROFESSIONAL_DETAILS.CURRICULAM]: Array.isArray(personalDetail.curriculum) ? personalDetail.curriculum : [personalDetail.curriculum],
        // [PROFESSIONAL_DETAILS.TEACHING_MODE]: personalDetail.teaching_mode,
        // [PROFESSIONAL_DETAILS.EXPERIENCE]: "",
        [PROFESSIONAL_DETAILS.SKILLS]: "",
      });

      setSkillsList(personalDetail.skills);
      // personalDetail.subject_and_experience? setExpSubject(personalDetail.subject_and_experience) : setExpSubject([]);
      personalDetail.subject_and_experience ? setCoursePayload(personalDetail.subject_and_experience) : setCoursePayload([]);

    }
    // setModeOfTeaching(`${personalDetail.teaching_mode}`);

  };

  const getGradesList = (value: any) => {
    axiosInstance.get(API_END_POINTS.GET_GRADES_LIST + `?is_type=False`).then(response => {
      if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
        setGradesList(response.data.result.data)
        // value==='False' ? setGradesList(response.data.result.data) : setYearsList(response.data.result.data);
        setGradesListIndex(response.data.result.data)
      }
    })
  }


  /* Getting user detail */
  const getRegistrationDetail = (API_END_POINT: any) => {
    axiosInstance.get(API_END_POINT).then((response) => {
      if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
        setEditable(response.data.result.data[NUMBER_CONSTANTS.ZERO]?.status);
        setPersonalDetail(response.data.result.data[NUMBER_CONSTANTS.ZERO]);
      }
    })
  }

  /* Getting category list */
  const getCategoriesList = (API_POINT: any) => {
    axiosInstance.get(API_POINT).then((response: any) => {
      if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
        setSubjectList(response.data.result.data);
        setSubjectListCopy(response.data.result.data);
      }
    });
  };

  /* Getting curriculam list */
  const getCurriculamList = () => {
    axiosInstance.get(API_END_POINTS.CURRICULAM_LIST).then((response: any) => {
      if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
        setCurriculamList(response.data.result.data);
      }
    })
  }

  /*geting seteled category detailes */
  const getValidateCategoryDetailes = () => {
    axiosInstance.get(API_END_POINTS.MANAGE_CATEGORY)
    .then((res:any)=>{
      if(res.data[API_RESPONSE.STATUS]) {
        setCategoryValidationDetails(res.data.result.data)
        setOpen(true)
      }
    })
  }

  /*Category validation */
  const validateCategory = () => {
    let payload = {
      "category_id": +courseSubject.id || null
    }
    axiosInstance.post(API_END_POINTS.MANAGE_CATEGORY, payload)
    .then(
      (res:any) => {
        if(!res.data.result.data.status) {
          getValidateCategoryDetailes()
          setCategoryValidationMessage(res.data.message)
        } else {
          onAddSubjects()
        }
      }
    ).catch(()=>{
    })
  } 
  
  /*undate or accept commision change */
  const putValidationCategory = () => {
    let payload = {
      "id":categoryValidationDetails?.id, 
      "category_id": categoryValidationDetails?.category_id ,
      "teach_service_provider_id": categoryValidationDetails?.teach_service_provider,
      "status":"accepted"
    }
    axiosInstance.put(API_END_POINTS.MANAGE_CATEGORY, payload)
    .then((res:any)=>{
      if(res.data[API_RESPONSE.STATUS]) {
        onAddSubjects()
        handleClose()
      }
    })
  }

  /* Yup validation schema */
  const formValidationSchema = yup.object({
    [PROFESSIONAL_DETAILS.DEGREE]:
      degreeList?.length > 0 ?
        yup
          .string()
          .required(REGISTRATION_ERRORS.DEGREE) :
        yup
          .string(),

    [PROFESSIONAL_DETAILS.HIGHER_EDUCATION]: yup
      .string()
      .required(REGISTRATION_ERRORS.DEGREE),

    [PROFESSIONAL_DETAILS.DEGREE_SUBJECT]: yup
      .string()
      .required(REGISTRATION_ERRORS.DEGREE),

    [PROFESSIONAL_DETAILS.CURRICULAM]: yup
      .array()
      .required(REGISTRATION_ERRORS.CURRICULUM),
    /* [PROFESSIONAL_DETAILS.TEACHING_MODE]: yup
      .string()
      .required(REGISTRATION_ERRORS.MODE_OF_TEACHING), */
    [PROFESSIONAL_DETAILS.SKILLS]: yup
      .array()
      .of(yup.string())
  });


  /* Update subject state */
  const onSelectSubjects = (event: any) => {
    setSelectedSubjects(event.target.value);
  };

  /* Setting experience */
  const onChangeExperience = (event: any) => {
    if (event.target.value <= 100 && courseSubject?.min_experience) {
      setExperience(event.target.value);
      if (event.target.value >= courseSubject?.min_experience) {
        setExperienceErrText(false)
      } else {
        setExperienceErrText(true)
      }
    }
  };

  useEffect(() => {
  }, [subjectList])

  useEffect(() => {
    let keyArr: any = [];
    expSubject?.forEach((obj: any) => {
      keyArr.push(obj.subject);
    });
    setCourses(keyArr);
    userType === `${NUMBER_CONSTANTS.FOUR}` ?
      setSubjectList(subjectListCopy.filter((item: any, index: any) => !keyArr.includes(item.course_category_name))) :
      setSubjectList(subjectListCopy.filter((item: any, index: any) => !keyArr.includes(item.category_name)))
    setExperience('');
    setSelectedSubjects('');

  }, [expSubject, subjectListCopy])
  const [subjectExperience, setSubjectExperience]: any = useState([]);
  useEffect(() => {
    setExperience("");
    setMinimumGradeYear("");
    setMaximumGradeYear("");
    setExpectedFee("");
    setCourseSubject(" ")
    setCourseFormSubmitted(API_RESPONSE.FALSE);
    setModeOfTeaching("");
    setSubjectPayload();
  }, [coursePayload]);


  useEffect(() => {
  }, [subjectExperience])
  const setSubjectPayload = () => {
    var payload = coursePayload;
    let result = payload.reduce(function (r: any, a: any) {
      r[a.subject] = r[a.subject] || [];
      r[a.subject].push(a);
      return r;
    }, Object.create(API_RESPONSE.NULL));
    setSubjectExperience(result)
  };

  /* Setting course payload */
  const onAddSubjects = () => {
    setCourseFormSubmitted(API_RESPONSE.TRUE);
    let isNum = /^\d+(\.\d+)?$/.test(expectedFee);
    if (experience && isNum && gradeType && minimumGradeYear && courseSubject.id) {
      const gradeYears = Array.isArray(minimumGradeYear) ? minimumGradeYear : [minimumGradeYear];

      const newPayload = gradeYears.map((year) => ({
        id: courseSubject.id,
        subject: courseSubject.course_category_name,
        experience: experience,
        expected_fee: expectedFee,
        min: year,
        grade: year,
        max: maximumGradeYear,
        type: gradeType,
        course_mode: modeOfTeching,
        location: locations
      }));

      // Append the new payload entries to `coursePayload`
      setCoursePayload([...coursePayload, ...newPayload]);
    } else {
      if (!courseSubject?.trim("")) {
        setCourseSubject(" ")
      }
    }


    //Old logic of removing subject
    /* setExpSubject([...expSubject, {      
       "id":selectedSubjects.id,
       "subject":userType===`${NUMBER_CONSTANTS.FOUR}` ? selectedSubjects.course_category_name : selectedSubjects.category_name,
       "experience":experience      
   }]); */


  };

  /* Edit Added Subject */
  const onEditSubject = (course: any) => {
    let courseIndex = coursePayload.indexOf(course);
    let coursePay = coursePayload;
    coursePay[courseIndex].isEdit ?
      coursePay[courseIndex].isEdit === API_RESPONSE.TRUE ? coursePay[courseIndex].isEdit = API_RESPONSE.FALSE : coursePay[courseIndex].isEdit = API_RESPONSE.TRUE :
      coursePay[courseIndex].isEdit = API_RESPONSE.TRUE;
    setCoursePayload([...coursePay]);
  };

  /* Edit Expected fee */
  const onEditInput = (course: any, fee: any) => {
    let courseIndex = coursePayload.indexOf(course);
    let coursePay = coursePayload;
    coursePay[courseIndex].expected_fee = fee;
    setCoursePayload([...coursePay])
  };

  /* Delete particular subject from subject list*/
  const onDeleteSubject = (course: any, index: any) => {
    let res = coursePayload?.find((res: any) => res?.min == course
    )
    let courseIndex = coursePayload.indexOf(course);
    let coursePay = coursePayload;
    coursePay.splice(courseIndex, NUMBER_CONSTANTS.ONE);
    setCoursePayload([...coursePay])
  };


  /* Deleting tag from taglist */
  const handleDelete = (i: any) => () => {
    setSkillsList(skillsList.filter((item: any) => item !== skillsList[i]));
  };


  /* Deleting subjects from list */
  const handleDeleteSubject = (index: any) => () => {
    //  setExpSubject(expSubject.filter((_:any, i:any) => i !== index));
    setCoursePayload(coursePayload.filter((_: any, i: any) => i !== index));


  };

  /* Handling enter keypress */
  const handleKeyPress = (event: any) => {
    if (
      event.key === VALIDATION_CONSTANT.KEY_TYPE &&
      nullUndefinedEmptyCheck(event.target.value.trim())
    ) {
      onAddTag();
    }
  };


  /* Managing Skills */
  const onAddTag = () => {
    if (
      nullUndefinedEmptyCheck(currentTag.trim()) &&
      skillsList.filter((item: any) => item === currentTag)?.length === NUMBER_CONSTANTS.ZERO
    ) {
      setSkillsList([...skillsList, currentTag]);
    } else {
      if (nullUndefinedEmptyCheck(currentTag.trim())) toast.error(ERROR_MESSAGES.SKILL_VALIDATION);
    }
    setCurrentTag("");
  };

  /* Setting current input value */
  const setInputValue = (e: any) => {
    /* if (
      REGEX.ENGLISH_INPUT_VALIDATION.test(e.target.value) &&
      !/[0-9.]/.test(e.key)
    ) { */
    setCurrentTag(e.target.value);
    // }
  };
  /* Submit API call */
  const onSubmitData = (payload: any) => {
    payload.courses = skillsList;
    payload.skills = skillsList;
    payload.subject_and_experience = coursePayload;
    payload.teaching_mode = `${NUMBER_CONSTANTS.ONE}`
    if (coursePayload?.length > NUMBER_CONSTANTS.ZERO) {
      let END_POINT = location.pathname === ROUTES.PROFILE ? API_END_POINTS.TUTOR_PROFILE_UPDATE : API_END_POINTS.TUTOR_VERIFY;
      axiosInstance.put(END_POINT + `?${VALIDATION_CONSTANT.PAGE}=` + NUMBER_CONSTANTS.TWO, payload).then((response: any) => {
        if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
          toast.success(response.data.message, TOASTER_CONFIGS);
          if (location.pathname !== ROUTES.PROFILE) {
            onNavigate(NUMBER_CONSTANTS.THREE);
            setSubjectExperience([]);
            setCoursePayload([]);
          }

        }
      })
    } else {
      toast.error(REGISTRATION_ERRORS.ADD_SUBJECT);
    }

  };

  /* Navigate call */
  const onNavigate = (state: any) => {
    props.setActiveStatus(state);
  };

  const getDegreeList = (value: any) => {
    let listIndex = highestQulaificationList.findIndex((data: any, index: number) => {
      return data.highest_education === value;
    });
    if (listIndex >= 0)
      getHighestQualification(highestQulaificationList[listIndex]?.id)

  };

  const cityOptions: string[] = [
    'Dubai',
    'Abu Dhabi',
    'Sharjah',
    'Ajman',
    'Al Ain',
    'Fujairah',
    'Ras Al-Khaimah',
    'Umm Al-Quwain',
  ];

  // const LatLanLip = ({ country, region }: any) => {
  //   useEffect(() => {
  //     if (region || country) {

  //       const apiUrl = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(country === UNITED_ARAB ? region.join(" ") : country)}&key=${process.env.REACT_APP_GOOGLE_API_KEY}`;

  //       fetch(apiUrl).then((response) => response.json())
  //         .then((data) => {
  //           const { latitude, lng } = data?.results[0]?.geometry?.location || {};
  //           return { state: region, latitude, lng };
  //         })
  //     }


  //   }, [country, region])
  //   return null
  // }

  const handleRegionChange = async (event: any, newValue: string[]) => {
    setRegion(newValue);

    // Fetch coordinates for each selected region
    const promises = newValue.map((region) =>
      fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
          country === UNITED_ARAB ? region : country
        )}&key=${process.env.REACT_APP_GOOGLE_API_KEY}`
      )
        .then((response) => response.json())
        .then((data) => {
          const { lat, lng } = data?.results[0]?.geometry?.location || {};
          return { state: region, latitude: lat, longitude: lng, radius: 15 };
        })
    );

    // Wait for all fetches to complete
    const resolvedLocations = await Promise.all(promises);
    setLocations(resolvedLocations);
  };
  const radiusHandleChange = (event: any) => {
    const radius = event?.target?.value;

    setLocations((prelocation) =>
      prelocation?.map((location: any) => ({
        ...location,
        radius: radius,
      }))
    );
  };

  return (
    <div className="row details-wrapper">
      <div className="col-md-12">
        <Card className="pd-card-wrapper">
          {userType === `${NUMBER_CONSTANTS.FOUR}` && <Formik
            initialValues={initialValues}
            validationSchema={formValidationSchema}
            enableReinitialize={API_RESPONSE.TRUE}
            onSubmit={(values, actions) => {
              onSubmitData(values);
            }}
          >
            {(formik: any) => {
              return (
                <div>
                  <div className="row row-wrap">
                    <div className="col-md-6">
                      <div className="form-items">
                        <label className="form-label mandatory">
                          {t("Highest Level of Education")}
                        </label>
                        <Field
                          as="select"
                          name={PROFESSIONAL_DETAILS.HIGHER_EDUCATION}
                          className="email-input"
                          placeholder={t("Ex: BE")}
                          onChange={(e: any) => {
                            formik.setFieldValue(
                              PROFESSIONAL_DETAILS.HIGHER_EDUCATION,
                              e.target.value
                            );
                            getDegreeList(e.target.value);
                          }}
                          value={formik.values[PROFESSIONAL_DETAILS.HIGHER_EDUCATION]}
                          disabled={editable == "approved" ? true : false}
                        >
                          <option value="">Please select highest qualification</option>
                          {highestQulaificationList.map((qualification: any, index: number) => {
                            return (
                              <option value={qualification.highest_education}>{qualification.highest_education}</option>
                            )
                          })}
                        </Field>
                        <div className="errorMessage">
                          {formik.touched[PROFESSIONAL_DETAILS.HIGHER_EDUCATION] &&
                            formik.errors[PROFESSIONAL_DETAILS.HIGHER_EDUCATION] && (
                              <p>
                                {t(
                                  `${formik.errors[PROFESSIONAL_DETAILS.HIGHER_EDUCATION]
                                  }`
                                )}
                              </p>
                            )}
                        </div>
                      </div>
                    </div>
                    {enableDegree && <div className="col-md-6">
                      <div className="form-items">
                        <label className="form-label mandatory">
                          {t("Degree")}
                        </label>
                        <Field
                          as="select"
                          name={PROFESSIONAL_DETAILS.DEGREE}
                          className="email-input"
                          value={formik.values[PROFESSIONAL_DETAILS.DEGREE]}
                          disabled={editable == "approved" ? true : false}
                        >
                          <option value="">Please select degree type</option>
                          {degreeList?.map((qualification: any, index: number) => {
                            return (
                              <option value={qualification.highest_education}>{qualification.highest_education}</option>
                            )
                          })}
                        </Field>
                        <div className="errorMessage">
                          {formik.touched[PROFESSIONAL_DETAILS.DEGREE] &&
                            formik.errors[PROFESSIONAL_DETAILS.DEGREE] && (
                              <p>
                                {t(
                                  `${formik.errors[PROFESSIONAL_DETAILS.DEGREE]
                                  }`
                                )}
                              </p>
                            )}
                        </div>
                      </div>
                    </div>}
                    <div className="col-md-6">
                      <div className="form-items">
                        <label className="form-label mandatory">
                          {t("Degree Specialization")}
                        </label>
                        <Field
                          name={PROFESSIONAL_DETAILS.DEGREE_SUBJECT}
                          className="email-input"
                          placeholder={"Degree Specialization"}
                          maxLength={150}
                          value={formik.values[PROFESSIONAL_DETAILS.DEGREE_SUBJECT]}
                          disabled={editable == "approved" ? true : false}
                        />

                        <div className="errorMessage">
                          {formik.touched[PROFESSIONAL_DETAILS.DEGREE_SUBJECT] &&
                            formik.errors[PROFESSIONAL_DETAILS.DEGREE_SUBJECT] && (
                              <p>
                                {t(
                                  `${formik.errors[PROFESSIONAL_DETAILS.DEGREE_SUBJECT]
                                  }`
                                )}
                              </p>
                            )}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-items">
                        <label className="form-label mandatory">{t("Curriculum You Teach")}</label>
                        <Select
                          multiple={true}
                          name={PROFESSIONAL_DETAILS.CURRICULAM}
                          className="filter-select email-input"
                          value={formik.values[PROFESSIONAL_DETAILS.CURRICULAM]}
                          disabled={editable == "approved" ? true : false}
                          onChange={(e: any) => {
                            formik.setFieldValue(
                              PROFESSIONAL_DETAILS.CURRICULAM,
                              e.target.value
                            );
                          }}

                        >
                          <MenuItem selected value={" "}>Please select curriculam</MenuItem>
                          {
                            curriculamList.map((curriculam: any) => {
                              return (
                                <MenuItem value={curriculam}>{curriculam}</MenuItem>
                              )
                            })
                          }
                        </Select>
                        {/* <Select
                            name={PROFESSIONAL_DETAILS.SUBJECT}
                            value={courseSubject}
                            className="filter-select"
                            onChange={(e: any) => {
                              setCourseSubject(e.target.value);
                              const minIndex = gradesListIndex?.indexOf(e.target.value?.min_grade);
                              const maxIndex = gradesListIndex?.indexOf(e.target.value?.max_grade);
                              const filtered = gradesListIndex?.slice(minIndex, maxIndex + 1);
                              setGradesList(filtered);
                            }

                            }
                          >
                            <MenuItem value={" "}>Please select teaching subject</MenuItem>
                            {subjectList?.map((sub: any, index: any) => {
                              return (
                                <MenuItem value={sub}>
                                  {userType === `${NUMBER_CONSTANTS.FOUR}` ? sub.course_category_name : sub.category_name}
                                </MenuItem>
                              );
                            })}
                          </Select> */}
                        <div className="errorMessage">
                          {formik.touched[PROFESSIONAL_DETAILS.CURRICULAM] &&
                            formik.errors[PROFESSIONAL_DETAILS.CURRICULAM] && (
                              <p>
                                {t(
                                  `${formik.errors[
                                  PROFESSIONAL_DETAILS.CURRICULAM
                                  ]
                                  }`
                                )}
                              </p>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row row-wrap">
                    <div className="col-md-6">
                      <div className="form-items">
                        <label className="form-label mandatory">{t("Tutoring Subjects")}</label>
                      </div>
                    </div>
                  </div>

                  <div className="subject-wrapup">
                    <div className="row row-wrap">

                      <div className="col-md-6">

                        <div className="form-items">
                          <label className="form-label mandatory">
                            {t("School Subjects ")}
                          </label>
                          <Select
                            name={PROFESSIONAL_DETAILS.SUBJECT}
                            value={courseSubject}
                            className="filter-select"
                            onChange={(e: any) => {
                              setCourseSubject(e.target.value);
                              const minIndex = gradesListIndex?.indexOf(e.target.value?.min_grade);
                              const maxIndex = gradesListIndex?.indexOf(e.target.value?.max_grade);
                              const filtered = gradesListIndex?.slice(minIndex, maxIndex + 1);
                              setGradesList(filtered);
                              setYearsList(filtered);
                            }

                            }
                          >
                            <MenuItem value={" "}>Please select teaching subject</MenuItem>
                            {subjectList?.map((sub: any, index: any) => {
                              return (
                                <MenuItem value={sub}>
                                  {userType === `${NUMBER_CONSTANTS.FOUR}` ? sub.course_category_name : sub.category_name}
                                </MenuItem>
                              );
                            })}
                          </Select>
                          {courseFormSubmitted && !courseSubject.id && <div className="errorMessage">
                            <p>Please select subject</p>
                          </div>}
                        </div>

                      </div>
                      <div className="col-md-6">
                        <div className="form-items">
                          <label className="form-label mandatory">
                            {t("Years of Experience")}
                          </label>
                          <Field
                            name={PROFESSIONAL_DETAILS.EXPERIENCE}
                            className="email-input"
                            placeholder={t("Ex: 5 Years ")}
                            maxlength={5}
                            onInput={numberOnly}
                            onPaste={numberOnly}
                            value={experience}
                            onChange={onChangeExperience}
                            onKeyPress={(event: any) => {
                              if (event.key === VALIDATION_CONSTANT.KEY_TYPE) {
                                onAddSubjects();
                              }
                            }}
                          />

                        </div>
                        {experienceErrText && courseSubject && <div className="errorMessage">
                          <p>Please Enter Min expeience {courseSubject?.min_experience}</p>
                        </div>}
                        {courseFormSubmitted && !experience && <div className="errorMessage">
                          <p>Please add expeience</p>
                        </div>}
                      </div>
                    </div>
                    <div className="row row-wrap">
                      <div className="col-md-6">
                        <div>
                          <FormControl>
                            <label className="form-label mandatory">
                              {t("Type")}
                            </label>
                            <RadioGroup
                              row
                              aria-labelledby="demo-row-radio-buttons-group-label"
                              name="row-radio-buttons-group"
                              value={gradeType}
                              onChange={(e: any) => {
                                setGradeType(e.target.value);
                              }}
                            >
                              <FormControlLabel value="grade" control={<Radio />} label="Grade" />
                              <FormControlLabel value="year" control={<Radio />} label="Year" />

                            </RadioGroup>
                          </FormControl>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-items">
                          <label className="form-label mandatory">
                            {/* {gradeType === 'grade' ? t("Grade") : t("Year")} */}
                            {t("Grade/Year")}
                          </label>
                          {/* <Field
                            as="select"
                            name={PROFESSIONAL_DETAILS.TEACHING_MODE}
                            value={minimumGradeYear|| ""}
                            className="filter-select email-input"
                            onChange={(e: any) => {
                              formik.setFieldValue(
                                setMinimumGradeYear(e.target.value)
                              );
                            }}
                          >
                            <option value={""}>{`Please select grade/year`}</option>
                           
                             
                              {gradesList.map((grade: any) => {
                                return (
                                  <option value={grade}>{grade}</option>
                                )
                              }) }
                          </Field> */}
                          <Autocomplete
                            multiple
                            id="grades-autocomplete"
                            options={gradesList}
                            value={minimumGradeYear || []}
                            onChange={(e: any, newValue: any) => {
                              setMinimumGradeYear(newValue);
                              formik.setFieldValue("minimumGradeYear", newValue);
                            }}
                            sx={{
                              backgroundColor: "#FFFFFF",
                              borderRadius: "11px",
                              "& .MuiFilledInput-root": {
                                backgroundColor: "#FFFFFF",
                                borderRadius: "11px",
                                "&:before": {
                                  borderBottom: "none",
                                },
                                "&:after": {
                                  borderBottom: "none",
                                },
                                "&:hover:not(.Mui-disabled):before": {
                                  borderBottom: "none",
                                },
                              },
                              "& .MuiAutocomplete-popupIndicator": {
                                color: "inherit",
                              },
                            }}
                            renderTags={(value: readonly string[], getTagProps) =>
                              value.map((option: string, index: number) => (
                                <Chip
                                  variant="outlined"
                                  label={option}
                                  {...getTagProps({ index })}
                                />
                              ))
                            }

                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="filled"
                                placeholder="Please select grade/year"
                              />
                            )}
                          />

                        </div>

                        {courseFormSubmitted && !minimumGradeYear && <div className="errorMessage">
                          <p>{gradeType === 'grade' ? "Please add grade" : "Please add year"}</p>
                        </div>}
                      </div>


                    </div>
                    <div className="row row-wrap">
                      <div className="col-md-6">
                        <div className="form-items">
                          <label className="form-label mandatory">
                            {t("Mode of Teaching")}
                          </label>
                          <Field
                            as="select"
                            name={PROFESSIONAL_DETAILS.TEACHING_MODE}
                            value={modeOfTeching}
                            className="filter-select email-input"
                            onChange={(e: any) => {
                              formik.setFieldValue(
                                PROFESSIONAL_DETAILS.TEACHING_MODE,
                                e.target.value
                              );
                              setModeOfTeaching(e.target.value);
                            }}
                          >
                            <option value="">Please select mode of teaching</option>
                            <option value="1">Online</option>
                            <option value="2">On-premises</option>
                          </Field>
                          {courseFormSubmitted && !modeOfTeching && <div className="errorMessage">
                            <p>Please select mode of teaching</p>
                          </div>}
                        </div>

                      </div>
                      <div className="col-md-6">
                        <div className="form-items">
                          <label className="form-label mandatory">
                            {t("Expected Fee (AED) per Hour")}
                          </label>
                          <Field
                            name={PROFESSIONAL_DETAILS.EXPERIENCE}
                            className="email-input"
                            placeholder={t("Ex: XXX (AED)")}
                            maxlength={5}
                            value={expectedFee}
                            onInput={numberOnly}
                            onPaste={numberOnly}
                            onChange={(e: any) => {
                              if (e.target.value <= parseInt(courseSubject.max_price)) {
                                setExpectedFee(e.target.value)
                              }
                            }}

                          />

                        </div>
                        {courseFormSubmitted && !expectedFee && <div className="errorMessage">
                          <p>Please add expected fee</p>
                        </div>}

                        {courseFormSubmitted && !(/^\d+(\.\d+)?$/.test(expectedFee)) && <div className="errorMessage">
                          <p>Please add valid number</p>
                        </div>}
                      </div>
                      {/*   <div className="col-md-6">
                      <div className="form-items">
                      <label className="form-label mandatory">
                      {gradeType==='grade' ? t("Maximum Grade") : t("Maximum Year")}
                          </label>
                         <Field
                          //  name={PROFESSIONAL_DETAILS.EXPERIENCE}
                           className="email-input"
                           placeholder={gradeType==='grade' ? t("Maximum Grade") : t("Maximum Year")}
                           maxlength={2}
                           onInput={numberOnly}
                           onPaste={numberOnly}
                           value={maximumGradeYear}
                           onChange={(e:any)=>{
                            setMaximumGradeYear(e.target.value)
                           }}
                          
                         />
                        </div>
                       {courseFormSubmitted &&  !maximumGradeYear && <div className="errorMessage">
                       <p>{gradeType==='grade' ? "Please add maximum grade" : "Please add maximum year"}</p>
                          </div>}
                       {(parseInt(maximumGradeYear) < parseInt(minimumGradeYear)) && <div className="errorMessage">
                       {gradeType==='grade' ? "Maximum grade should be greater than or equal to minimum grade" : "Maximum year should be greater than or equal to minimum year"}
                            
                          </div>}
                      </div> */}
                    </div>
                    {
                      modeOfTeching == 2 && (
                        <div className="row row-wrap">
                          <div className="col-md-6">
                            <div className="form-items">
                              <label className="form-label mandatory">
                                {t("State")}
                              </label>
                              <div className="">
                                <Autocomplete
                                  multiple
                                  componentName={PROFESSIONAL_DETAILS?.STATE}
                                  id="fixed-tags-demo"
                                  className="autocomplete-input"
                                  value={region}
                                  disableCloseOnSelect
                                  onChange={handleRegionChange}
                                  options={cityOptions}

                                  style={{
                                    borderRadius: '11.621px',
                                    background: '#ffffff',
                                    height: '50px',
                                    width: '460px',
                                  }}
                                  renderInput={(params) => (
                                    <TextField {...params} label="" placeholder="Add Address" />
                                  )}
                                />
                                {courseFormSubmitted && locations?.length == 0 && <div className="errorMessage">
                                  <p>Please add State</p>
                                </div>}
                              </div>

                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-items">
                              <label className="form-label mandatory">
                                {t("Radius")}
                              </label>
                              <div className="">
                                <input
                                  name={PROFESSIONAL_DETAILS?.RADIUS}
                                  className="email-input"
                                  placeholder="Enter Radius" type="number"
                                  onChange={radiusHandleChange} />

                              </div>
                            </div>
                          </div>
                        </div>
                      )
                    }

                    <div className="add-btn-wrapper">
                      <button
                        className="btn btn-secondary add-btn mt-2"
                        onClick={() => {
                          if (!experienceErrText) {
                            // onAddSubjects()
                            validateCategory()
                          }
                        }}>Add</button>
                    </div>
                    {/*   {formSubmitted &&  coursePayload?.length===0 && <div className="errorMessage">
                              <p>Please add subject and its relevent fields</p>
                          </div>} */}
                  </div>
                  <div className="row row-wrap">
                    <div className="col-md-6">
                      <div className="form-items">
                        <label className="form-label">{t("Skills")}</label>
                        <Field
                          name={PROFESSIONAL_DETAILS.SKILLS}
                          className="email-input"
                          value={currentTag}
                          placeholder={t("Ex: Leadership")}
                          onKeyPress={(event: any) => {
                            handleKeyPress(event);
                          }}
                          disabled={editable == "approved" ? true : false}
                          onBlur={() => {
                            setSkillsTouched(API_RESPONSE.TRUE);
                          }}
                          onChange={(e: any) => {
                            setInputValue(e);
                          }}
                        />
                        <img
                          className="plus-image"
                          src={plus}
                          //   onClick={()=>{onAddTag;formik.setFieldValue(PROFESSIONAL_DETAILS.SKILLS,skillsList)}}
                          onClick={onAddTag}
                        />
                      </div>
                      {/* <div className="errorMessage">
                        {((skillsList?.length === NUMBER_CONSTANTS.ZERO &&
                          skillsTouched === API_RESPONSE.TRUE) || (formSubmitted && skillsList?.length === NUMBER_CONSTANTS.ZERO)) && (
                            <p>
                              {t(
                                `${REGISTRATION_ERRORS.SKILLS}`
                              )}
                            </p>
                          )}
                      </div> */}
                      <div className="skills-list">
                        {skillsList?.map((skill: any, index: any) => {
                          return (
                            <Chip
                              className="skill-chip"
                              label={skill}
                              variant="outlined"
                              onDelete={handleDelete(index)}
                            />
                          );
                        })}
                      </div>

                    </div>
                  </div>
                  <div className="row subject-list">
                    {/*  {
                      coursePayload.map((course:any,index:any)=>{
                        return(
                          <div className="col-xs-12 col-sm-12 col-md-4 detail-wrapper" >
                          <div className="session_card_container row-wrap">
                       
                          <div className="session_slot_count_wrapper">
                         <div className="session_slot_count">
                         <div className="session-count">{course.experience}</div>
                         <div className="slot-text">Experience</div>
                         </div>
                        
                       </div>
                       <div className="session_date_details_container">
                         <div className="session_subject">{course.course_mode===`${NUMBER_CONSTANTS.ONE}` ? 'Online' : 'Offline'}</div>
                         <div className="session_grade">{course.min} - {course.max } {course.type} </div>
                         <div className="session_grade"><input value={course.expected_fee}/>AED</div>
                       </div>
                       <div className="close_icon_button">
                          
                           <CloseIcon className="close_icon"  onClick={handleDeleteSubject(index)}/>
                          </div> 
                     </div>
                     
                       </div>
                        )
                      })
                    } */}
                    {
                      Object.keys(subjectExperience).map((title: any) => {
                        return (
                          <div className="col-xs-12 col-sm-12 col-md-12 detail-wrapper" key={title}>
                            <h5>{title}</h5>
                            <div className="session_card_container row-wrap">
                              {subjectExperience[title].map((course: any, index: any) => (
                                <div className="subject-detail-wrapper" key={course.id}>
                                  <div className="approval-label">
                                    {course.status === 'approved'
                                      ? "Approved"
                                      : course.status === 'rejected'
                                        ? "Rejected"
                                        : "Approval Pending"}
                                  </div>
                                  <div className="session_slot_count_wrapper mt-1">
                                    <div className="session_slot_count">
                                      <div className="session-count">{course.experience}</div>
                                      <div className="slot-text">Experience</div>
                                    </div>
                                  </div>
                                  <div className="session_date_details_container mt-1">
                                    <div className="session_subject">
                                      {course.course_mode === `${NUMBER_CONSTANTS.ONE}` ? 'Online' : 'On-premises'}{' '}
                                      {course.status === 'rejected' && (
                                        <Tooltip title={course?.reason}>
                                          <InfoOutlinedIcon style={{ fontSize: "16px" }} className="info-icon" />
                                        </Tooltip>
                                      )}
                                    </div>
                                    <div className="session_grade">{course.grade}</div>
                                    {course.isEdit === true && (
                                      <div className="session_grade">
                                        <input
                                          value={course.expected_fee}
                                          onChange={(e: any) => {
                                            let maxValue = subjectList.filter((sub: any) => {
                                              return sub.course_category_name === course.subject;
                                            });
                                            if (e.target.value <= parseInt(maxValue[0]?.max_price)) {
                                              onEditInput(course, e.target.value);
                                            }
                                          }}
                                        />
                                        AED{' '}
                                        <DoneIcon
                                          className="edit-icon"
                                          onClick={() => {
                                            onEditSubject(course);
                                          }}
                                        />
                                      </div>
                                    )}
                                    {!course.isEdit && (
                                      <div className="session_grade">
                                        {course.expected_fee} AED{' '}
                                        {course.status !== 'approved' && (
                                          <EditIcon
                                            className="edit-icon"
                                            onClick={() => {
                                              onEditSubject(course);
                                            }}
                                          />
                                        )}
                                      </div>
                                    )}
                                  </div>
                                  {course.status !== 'approved' && (
                                    <div className="clear-icon-wrapper">
                                      <ClearIcon
                                        className="clear-icon"
                                        onClick={() => {
                                          onDeleteSubject(course, index);
                                        }}
                                      />
                                    </div>
                                  )}
                                </div>
                              ))}
                            </div>
                          </div>
                        );
                      })
                    }


                  </div>

                  <CategoryValidationDialog
                  open={open}
                  onClose={handleClose}
                  message={categoryValidationMessage}
                  update={putValidationCategory}
                  />
                  
                  {/*                     <div className="row row-wrap">
                    <label className="form-label mandatory">
                            {t("Teaching Subjects & Years of Experience")}
                          </label>
                      <div className="col-md-6">
                      
                      <div className="form-items">
                          
                          <Select
                            // multiple
                            name={PROFESSIONAL_DETAILS.SUBJECT}
                            value={selectedSubjects}
                            className="filter-select"
                            onChange={(e:any)=>{
                              onSelectSubjects(e);
                              formik.setFieldValue(
                                PROFESSIONAL_DETAILS.SUBJECT,
                                e.target.value
                              );
                            }
                             
                            }
                          >
                            {subjectList?.map((sub: any, index: any) => {
                              return (
                                <MenuItem value={sub}>
                                {userType===`${NUMBER_CONSTANTS.FOUR}` ? sub.course_category_name : sub.category_name}
                                </MenuItem>
                              );
                            })}
                          </Select>
                          <div className="errorMessage">
                            {formik.touched[PROFESSIONAL_DETAILS.SUBJECT] &&
                              formik.errors[PROFESSIONAL_DETAILS.SUBJECT] && (
                                <p>
                                  {t(
                                    `${
                                      formik.errors[PROFESSIONAL_DETAILS.SUBJECT]
                                    }`
                                  )}
                                </p>
                              )}
                          </div>
                        </div>
  
                      </div>
                      <div className="col-md-5">
                      <div className="form-items">
                         
                          <Field
                            name={PROFESSIONAL_DETAILS.EXPERIENCE}
                            className="email-input"
                            placeholder={t("Years of Experience")}
                            maxlength={5}
                            value={experience}
                            onChange={onChangeExperience}
                            onKeyPress={(event: any) => {
                              if( event.key === VALIDATION_CONSTANT.KEY_TYPE){
                                onAddSubjects();
                              }                       
                            }}
                          />
                         
                        </div>
                      </div>
                      <div className="col-md-1 add-btn-wrapper">
                        <button 
                        className="btn btn-secondary add-btn mt-2 w-100" 
                        onClick={()=>{onAddSubjects()}}>Add</button>
                      </div>
  
                     
                    </div>
                    {formSubmitted &&  expSubject?.length===0 && <div className="errorMessage">
                              <p>Please add subject and experience</p>
                          </div>} */}

                  {/*  <div className="row sub-exp-wrap">
                      <div className="col-md-12">
                      {expSubject?.map((obj: any,index:any) => {
                       return <>
                        <Chip
                          className="skill-chip"
                          label={obj.subject + ' - ' + obj.experience + (obj.experience >1 ?'years' : 'year')}
                          variant="outlined"
                          onDelete={handleDeleteSubject(index)}
                        />
                       </>
                       
                       
                      })
                      }
                      </div>
                          
                       
                      </div> */}
                  {location.pathname === ROUTES.PROFILE ?
                    <div className="bi-buttons-wrap">
                      {/* <button
                    className="btn btn-back"
                    onClick={() => onNavigate(1)}
                  >
                    Back
                  </button> */}
                      <button
                        className="btn btn-next"
                        type="submit"
                        onClick={() => {
                          setFormSubmitted(API_RESPONSE.TRUE);
                          formik.handleSubmit();
                        }}
                      >
                        Update
                      </button>
                    </div>
                    :

                    <div className="bi-buttons-wrap">
                      <button
                        className="btn btn-back"
                        onClick={() => onNavigate(1)}
                      >
                        Back
                      </button>
                      <button
                        className="btn btn-next"
                        type="submit"
                        onClick={() => {
                          setFormSubmitted(API_RESPONSE.TRUE);
                          formik.handleSubmit();
                        }}
                      >
                        Next
                      </button>
                    </div>
                  }


                </div>
              );
            }}
          </Formik>}


        </Card>
      </div>
    </div>
  )
};

export default Tutor;